import { ROOT_GLOBAL } from "../../global/root";
import { LocalStorage } from "../../models/LocalStorage";
import { MINI_APP } from "../../utils/miniApp";
import { DComponent } from "../DComponent";

class CollaboratorMenu extends DComponent {
  constructor({
    id,
    menu = "",
    isCollapse = false,
    addMemuMobile = () => { },
  } = {}) {
    super(arguments[0], ".main-page", id);
    this.isCollapse = isCollapse;
    this.menu = menu;
    this.addMemuMobile = addMemuMobile;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "CollaboratorMenu");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  before() {
    if (this.isCollapse) {
      this.parent.addClass("menu-collapse");
    }
    this.parent.css("display", "none");
    this.parent.css("padding-left", this.isCollapse ? "88px" : "242px");
  }

  after() {
    setTimeout(() => {
      this.parent.addClass("menu-animation");
      this.parent.css("display", "");
      this.parent.css("padding-left", "");
    }, 100);

    $("body").on("click", ".logo-link", (e) => {
      if (LocalStorage.isMiniApp() && !LocalStorage.isOldApp()) {
        e.preventDefault();
        MINI_APP.backHome();
      }
    })
  }

  afterElement() {
    this.setMenu();
    const burget = require("../../assets/images/menu/burger.svg");
    this.mobileMenu = $(`
      <div class="toggle-mobile">
        <div class="toggle-box">
          <div class="burger">
            <img alt="burger" src="${burget}" />
          </div>
        </div>
      </div>
    `);
    typeof this.addMemuMobile === "function" && this.addMemuMobile(this.mobileMenu);
    $(".bottom-box .btn-collapse", this.element).on("click", () => this.toggle());
    $(".burger", this.mobileMenu).on("click", () => this.show());
    $(".close-box", this.element).on("click", () => this.hide());
    if (this.menu) {
      $(`.item.m-${this.menu}`, this.element).addClass("active");
    }
    this.mobileMenu.i18n();
  }

  setMenu() {
    var root = window.location.pathname;
    if (root.includes(ROOT_GLOBAL.COLLABORATOR_DASHBOARD)) {
      this.menu = "dashboard";
    }
    if (root.includes(ROOT_GLOBAL.COLLABORATOR_PRODUCT)) {
      this.menu = "products";
    }
    if (root.includes(ROOT_GLOBAL.COLLABORATOR_PROFILE)) {
      this.menu = "profile";
    }
  }

  toggle() {
    this.parent.toggleClass("menu-collapse");
  }

  show() {
    this.parent.removeClass("menu-collapse");
  }

  hide() {
    if (!this.parent.hasClass("menu-collapse")) {
      this.parent.addClass("menu-collapse");
    }
  }
}

export default CollaboratorMenu;